
    // import { useState, useEffect } from 'react';
    // import { useNavigate, Outlet, Link, useLocation } from 'react-router-dom';

    // export default function AdminLayout() {
    // const [darkMode, setDarkMode] = useState(false);
    // const navigate = useNavigate();
    // const location = useLocation();

    // useEffect(() => {
    //     const stored = localStorage.getItem('darkMode');
    //     if (stored === 'true') setDarkMode(true);
    // }, []);

    // useEffect(() => {
    //     localStorage.setItem('darkMode', darkMode);
    //     document.documentElement.classList.toggle('dark', darkMode);
    // }, [darkMode]);

    // const handleLogout = () => {
    //     localStorage.removeItem('token');
    //     localStorage.removeItem('role');
    //     navigate('/admin-login');
    // };

    // const isActive = (path) => location.pathname === path;

    // return (
    //     <div className={`flex min-h-screen ${darkMode ? 'dark bg-gray-900 text-white' : 'bg-gray-50 text-gray-800'}`}>
    //     {/* Sidebar */}
    //     {/* <aside className="w-64 bg-white dark:bg-gray-800 shadow-md p-6">
    //         <h1 className="text-2xl font-bold mb-6 text-blue-600 dark:text-blue-400">Admin Panel</h1>
    //         <nav className="space-y-3">
    //         <Link to="/admin/dashboard" className={`block hover:font-semibold ${isActive('/admin/dashboard') ? 'font-bold text-blue-600' : ''}`}>User Management</Link>
    //         <Link to="/admin/settings" className={`block hover:font-semibold ${isActive('/admin/settings') ? 'font-bold text-blue-600' : ''}`}>Admin Settings</Link>
    //         <a href="http://127.0.0.1:8000/docs" target="_blank" className="block hover:font-semibold">Swagger Docs</a>
    //         <a href="/docs" target="_blank" className="block hover:font-semibold">Developer Docs</a>
    //         </nav>
    //         <div className="mt-10 flex flex-col gap-3">
    //         <button
    //             onClick={() => setDarkMode(!darkMode)}
    //             className="w-full bg-gray-200 dark:bg-gray-700 text-sm px-4 py-2 rounded hover:bg-gray-300 dark:hover:bg-gray-600"
    //         >
    //             Toggle {darkMode ? 'Light' : 'Dark'} Mode
    //         </button>
    //         <button
    //             onClick={handleLogout}
    //             className="w-full bg-red-600 text-white py-2 rounded hover:bg-red-700"
    //         >
    //             Logout
    //         </button>
    //         </div>
    //     </aside> */}
    //     <aside className="w-64 bg-white border-r shadow-md p-6">
    //     <h1 className="text-2xl font-bold mb-6">Dentulu Admin</h1>
    //     <nav className="space-y-3">
    //         <button onClick={() => setSection('dashboard')} className="w-full text-left hover:font-semibold">System Overview</button>
    //         <button onClick={() => setSection('users')} className="w-full text-left hover:font-semibold">Users</button>
    //         <button onClick={() => setSection('apps')} className="w-full text-left hover:font-semibold">Apps</button>
    //         <button onClick={() => setSection('logs')} className="w-full text-left hover:font-semibold">Logs</button>
    //         <button onClick={() => setSection('settings')} className="w-full text-left hover:font-semibold">Settings</button>
    //     </nav>

    //     <div className="mt-10 text-xs text-gray-400">
    //         Powered by Dentulu v1.0
    //     </div>
    //     </aside>
    //     {/* Main Content */}
    //     <main className="flex-1 p-8 bg-gray-100 dark:bg-gray-900">
    //         <Outlet />
    //     </main>
    //     </div>
    // );
    // }

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/shared/Sidebar';
import Header from '../components/shared/Header';
import Footer from '../components/shared/Footer';

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    sessionStorage.clear();
    localStorage.clear();
    navigate('/admin-login');
  };

  return (
    <div className="flex min-h-screen bg-gray-100">

      {/* ── Desktop sidebar — always visible on lg+, fixed position ── */}
      <div className="hidden lg:flex fixed top-0 left-0 h-screen z-30">
        <Sidebar role="admin" onLogout={handleLogout} />
      </div>

      {/* ── Mobile sidebar drawer ── */}
      {/* Backdrop */}
      {sidebarOpen && (
        <div
          className="lg:hidden fixed inset-0 z-40 bg-black/40"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      {/* Drawer */}
      <div
        className={`lg:hidden fixed top-0 left-0 z-50 h-full transform transition-transform duration-300 ease-in-out ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <Sidebar
          role="admin"
          onLogout={handleLogout}
          onClose={() => setSidebarOpen(false)}
        />
      </div>

      {/* ── Main content ── */}
      <div className="flex flex-col flex-1 min-w-0 lg:ml-64">
        <Header onMenuToggle={() => setSidebarOpen(true)} onLogout={handleLogout} />
        <main className="flex-1 p-4 lg:p-6">{children}</main>
        <Footer />
      </div>

    </div>
  );
}
